module.exports = __webpack_public_path__ + "img/one.fdd9926f.png";